'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgTarget2 } from '@common/icon';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { useShallow } from 'zustand/react/shallow';
import { AuthMutation, MEMBER_JOIN_STATUS } from '@/api';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { ROUTES } from '@/constants';
import { DEFAULT_LOCATION } from '@/constants/geo';
import { useLocation } from '@/hooks/useLocation';
import { useLocationConsent } from '@/hooks/useLocationConsent';
import { useAuthStore } from '@/stores/AuthStore';
export const RegionDrawer = () => {
  const $ = _c(15);
  const [isLogin, myInfo] = useAuthStore(useShallow(_temp));
  const queryClient = useQueryClient();
  const {
    isConsented
  } = useLocationConsent();
  const pathname = usePathname();
  const needRegionData = myInfo?.memberJoinStatus === MEMBER_JOIN_STATUS.EMPTY_FILTER && !(myInfo.codeRegion && myInfo.codeSubRegion);
  const location = useLocation();
  const {
    toastError
  } = useToast();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthMutation["post:/wello/v2/auth/member-filter/region"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = () => {
      queryClient.invalidateQueries();
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== toastError) {
    t2 = error => toastError({
      error
    });
    $[3] = toastError;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      ...t0,
      onSuccess: t1,
      onError: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const postRegionDataMutation = useMutation(t3);
  if (!pathname || !isLogin || isConsented === undefined) {
    return null;
  }
  let t4;
  if ($[8] !== pathname) {
    const enabledPaths = [ROUTES.HOME.pathname, ROUTES.MY.pathname, ROUTES.COMMUNITY.pathname, ROUTES.RECOMMEND_POLICY_LIST.pathname];
    const excludedPaths = [ROUTES.POINT_MARKET_HISTORY.pathname];
    t4 = enabledPaths.some(path_0 => pathname.startsWith(path_0)) && !excludedPaths.some(path => pathname.startsWith(path));
    $[8] = pathname;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const isEnabledPathname = t4;
  let t5;
  if ($[10] !== isEnabledPathname || $[11] !== location || $[12] !== needRegionData || $[13] !== postRegionDataMutation) {
    t5 = isEnabledPathname ? <ResponsiveDialog opened={needRegionData} drawerType="bottom" className={{
      backdrop: "z-50",
      drawer: "z-50"
    }}><h3 className="typo-body2-b mb-8 text-Gray-900">지역을 선택해 주세요</h3><p className="typo-body4-r mb-16 text-Gray-700">선택된 지역의 정책과 게시글을 볼 수 있어요.</p><ul className="pl-18 text-Gray-600 typo-caption1"><li className="list-disc">지역 설정은{" "}<span className="text-Gray-black">{"\uB9DE\uCDA4\uC815\uCC45 > \uB9DE\uCDA4\uC815\uBCF4 \uC218\uC815 > \uC9C0\uC5ED"}</span>에서 언제든지 수정할 수 있어요.</li><li className="list-disc">해외 접속 등 지역 정보 확인이 어려운 경우에는 '서울시 관악구'로 기본 설정돼요.</li></ul><Button className="mt-20 w-full" loading={location.isLoading || postRegionDataMutation.isPending} onClick={async () => {
        const {
          data
        } = await location.refetch();
        const codeRegion = data?.codeRegion ?? DEFAULT_LOCATION.codeRegion;
        const codeSubRegion = data?.codeSubRegion ?? DEFAULT_LOCATION.codeSubRegion;
        postRegionDataMutation.mutate({
          body: {
            codeRegion,
            codeSubRegion
          }
        });
      }}><SvgTarget2 className="mr-6 size-16" name={"\uD604\uC7AC \uC704\uCE58"} />현재 위치로 선택하기</Button></ResponsiveDialog> : null;
    $[10] = isEnabledPathname;
    $[11] = location;
    $[12] = needRegionData;
    $[13] = postRegionDataMutation;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
function _temp(state) {
  return [state.isLogin, state.myInfo];
}